import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';
import { ensureLanguageSynced, getGuiLanguage, getPreferredLanguage } from './config/languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { translation: zhCN },
      'en-US': { translation: enUS },
    },
    fallbackLng: 'zh-CN',
    // 避免浏览器探测出的 "en" / "zh" 等短码既不匹配资源、又被误发给后端
    supportedLngs: ['zh-CN', 'en-US'],
    nonExplicitSupportedLngs: false,
    interpolation: {
      escapeValue: false, // React 已自动转义
    },
    detection: {
      // 只信本应用写入的 i18nextLng；不再用 navigator，避免英文浏览器把 GUI/残留探测值带偏
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  })
  .then(() => {
    // 在探测完成后再对齐 language ↔ i18nextLng，保证 session_info 发出前已是中文默认
    ensureLanguageSynced(i18n);
    const guiLang = getGuiLanguage(getPreferredLanguage());
    if (i18n.language !== guiLang) {
      return i18n.changeLanguage(guiLang);
    }
  });

export default i18n;
